<template>
    <section :class="['widget', container,
                fixed ? 'widget-fixed' : '',
                fixed && !show ? 'd-none' : '']"
             :style="{'background-color': bgColor, 'border': border}">
        <header :class="['d-flex align-items-center justify-content-between',
                    {'stand-out': standOut}
                ]">
            <slot name="header"/>
            <span class="d-flex align-items-center close-button"
                  @click="$emit('close')"
                  v-if="closeable">
                x
            </span>
        </header>
        <div v-if="tabs">
            <ul class="tabs d-flex flex-wrap">
                <li v-for="(tab, index) in tabs"
                    :key="index"
                    :class="['tab-item',
                        {selected: activeTabName === (tabsByKey ? tab[tabKey] : tab)}
                    ]"
                    @click="tabIndex = index; $emit('update:tab', tab)">
                    {{tabsByKey ? tab[tabKey] : tab}}
                </li>
                <slot name="actionTabs"/>
            </ul>
        </div>
        <main class="d-flex flex-column">
            <slot name="body"/>
        </main>
        <footer class="d-flex align-content-center ">
            <slot name="footer"/>
        </footer>
    </section>
</template>

<script type="text/babel">

export default {
    name: 'CphWidget',
    data () {
        return {
            tabIndex: 0
        };
    },
    props: {
        container: {
            required: false,
            type: String,
            default: 'container'
        },
        standOut: {
            type: Boolean,
            required: false,
            default: false
        },
        activeTabName: {
            type: String
        },
        closeable: {
            type: Boolean,
            required: false,
            default: false
        },
        tabs: {
            type: [Array, Object],
            required: false
        },
        bgColor: {
            type: String
        },
        border: {
            type: String,
            default: ''
        },
        tabsByKey: {
            type: Boolean,
            default: false
        },
        tabKey: {
            type: String,
            default: ''
        },
        fixed: {
            default: false
        },
        show: {
            default: false
        }
    }
};

</script>

<style lang="scss" scoped>
    header {
        height: $standard-height;
        width: 100%;
    }
    
    .widget.container {
        padding: 0;
    }
    
    .widget {
        position: relative;
        @include color('background-color', background-color-light);
        @include color('color', text-color-dark);
        border-radius: 10px;
        
        &.widget-fixed {
            position: fixed !important;
            z-index: 10;
            top: 1em;
            right: 1em;
            left: 1em;
            bottom: 1em;
            overflow-y: auto;
        }
        
        main {
            padding: 15px 25px;
        }
        
        header {
            padding: 0 25px;
            h2 {
                margin-top: 15px;
            }
            .close-button {
                font-size: 2em;
                padding: 10px 0;
                cursor: pointer;
            }
            &.stand-out {
                @include color('background-color', primary-active);
                @include color('color', text-color-light);
                color: white;
                border-top-right-radius: 10px;
                border-top-left-radius: 10px;
            }
        }
    }
    
    .tabs {
        padding: 0;
        margin: 0;
        .tab-item {
            display: inline-block;
            padding: 0.5em 1em;
            font-size: 1.5em;
            cursor: pointer;
            transition: color 0.3s, background-color 0.3s;
            &.selected {
                @include color('background-color', primary-active);
                @include color('color', text-color-light);
            }
        }
    }
</style>
